import styled from 'styled-components';

const RelayionTypeSection = styled.div`
  .ant-radio-group {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  .ant-input-affix-wrapper .ant-input:not(:last-child) {
    font-size: 1.8rem;
    ${props => props.theme.device.md} {
      font-size: 2.4rem;
    }
  }
`;
export { RelayionTypeSection };
